define('models/budgetFlight',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.BudgetFlight = T1Model.extend({});
  return T1.Models.BudgetFlight;
});
